module.exports = __webpack_public_path__ + "static/media/1POLICY4.2acaa005.jpg";